// =========================================================
// 0. GLOBAL DATA CONFIGURATION (Accessible by both functions)
// =========================================================
const bundleConfig = {
    '/apps/gbb/easybundle/6': [ 
      '1 Combo Plate of 7" &amp; 10" - 24 Count',
      '1 Set of Lunch Napkin - 20 Count',
      '2 Flatware Combo - 40 Count',
      '2 Sets of Wine Glass - 5 Count',
      '2 Sets of Stemless Goblets - 6 Count',
      '3 Sets of Chargers - 4 Count'
    ],

    '/apps/gbb/easybundle/7': [ 
      '1 Square 10.75" Dinner Plate - 10 Count',
      '1 Square 7.75" Lunch Plate - 10 Count',
      '1 Set of Lunch Napkin - 20 Count',
      '2 Flatware Combo - 40 Count',
      '2 Sets of Wine Glass - 5 Count',
      '2 Sets of Stemless Goblets - 6 Count'
    ],

    '/apps/gbb/easybundle/8': [ 
      '1 Set of 10" Dinner Plate - 10 Count',
      '1 Set of 8" Salad Plate - 10 Count',
      '2 Sets of Stemless Goblets - 6 Count',
      '2 Flatware Combo - 40 Count',
      '2 Sets of Wine Glass - 5 Count',
      '3 Sets of Chargers - 4 Count',
      '1 Set of Lunch Napkin - 20 Count'
    ],

    '/apps/gbb/easybundle/9': [ 
      '1 Combo Plate of 7" &amp; 10" - 32 Count',
      '2 Sets of Wine Goblets - 5 Count',
      '2 Flatware Combo - 40 Count',
      '1 Set of Lunch Napkin - 20 Count',
      '1 Napkin holder'
    ],


    '/apps/gbb/easybundle/10': [ 
      '1 Combo plate of 7" &amp; 10" - 32 Count',
      '1 Set of Decorative Napkin - 20 Count',
      '2 Flatware Combo - 40 Count',
      '3 Sets of Wine Glass - 4 Count',
      '10 Pieces of Gold Placemat',
      '2 Sets of Champagne Flute - 6 Count'
    ],

    '/apps/gbb/easybundle/11': [ 
      '1 Set of 10" Design Plates - 10 Count',
      '1 Set of 7" Design Plates - 10 Count',
      '1 Set of Decorative Napkin - 20 Count',
      '2 Flatware Combo - 40 Count',
      '3 Set of Wine Glass - 4 Count',
      '10 Pieces of Gold Placemat',
      '2 Sets of Champagne Flute - 6 Count'
    ],
    
    '/apps/gbb/easybundle/12': [ 
      '1 10" Dinner Plate - 10 Count',
      '1 8" Lunch Plate - 10 Count',
      '3 Sets of 13" Chargers - 4 Count',
      '2 Sets of Wine Glass - 5 Count',
      '1 Set of Lunch Napkin - 20 Count',
      '2 Flatware Combo - 40 Count',
      '2 Sets of Champagne Flute - 6 Count'
    ]
};


// =========================================================
// 1. collectionBundle(): Handles restructuring the footer
// (No changes needed, as it already uses bundleConfig)
// =========================================================
function collectionBundle() {
    const targetClass = '.gbbPageFooterHTML';
    const mainFooterDiv = document.querySelector(targetClass);

    if (!mainFooterDiv || mainFooterDiv.querySelector('.gbbFooterContentWrapper')) {
        return;
    }
    
    const currentURL = window.location.href; 
    let newDivContent = '';
    
    // Find matching URL part and data
    const matchingUrlPart = Object.keys(bundleConfig).find(urlPart => currentURL.includes(urlPart));
    
    if (matchingUrlPart) {
        const matchingData = bundleConfig[matchingUrlPart];
        const itemsList = matchingData.map(item => `<li>${item}</li>`).join('');
        newDivContent = `<h4>THIS BUNDLE INCLUDES:</h4><ul>${itemsList}</ul>`;

        // --- DOM Restructuring Logic ---
        const currentContentDiv = document.createElement('div');
        currentContentDiv.classList.add('gbbFooterCurrentContent');
        const newDiv = document.createElement('div');
        newDiv.classList.add('gbbFooterNewDiv');
        newDiv.innerHTML = newDivContent; 
        const childrenToMove = Array.from(mainFooterDiv.children);
        childrenToMove.forEach(child => { currentContentDiv.appendChild(child); });
        const contentWrapper = document.createElement('div');
        contentWrapper.classList.add('gbbFooterContentWrapper');
        contentWrapper.appendChild(currentContentDiv);
        contentWrapper.appendChild(newDiv);
        mainFooterDiv.appendChild(contentWrapper);
        mainFooterDiv.style.display = 'block';
        contentWrapper.style.display = 'flex';
        contentWrapper.style.gap = '20px'; 
        currentContentDiv.style.flex = '1'; 
        newDiv.style.flex = '1'; 

        console.log("Footer successfully restructured.");
    }
}


// =========================================================
// 2. setupProductInteractions(): UPDATED TO USE bundleConfig MAP
// =========================================================
function setupProductInteractions() {
    const popupWrapper = document.querySelector('.product-includes-wrapper');
    const popupImage = popupWrapper ? popupWrapper.querySelector('.product-includes-img') : null;
    const popupList = popupWrapper ? popupWrapper.querySelector('.product-includes-detail ul') : null; 
    
    if (!popupWrapper || !popupList) {
        return; 
    }

    const closeButton = popupWrapper.querySelector('.product-includes-close');

    /** Core logic to attach click handlers to all product images. */
    function attachClickHandlers() {
        const imageWrappers = document.querySelectorAll('.product-image-wrapper');
        
        // Prevent re-attaching listeners
        if (imageWrappers.length > 0 && imageWrappers[0].hasAttribute('data-listeners-attached')) {
             return; 
        }

        imageWrappers.forEach(wrapper => {
            wrapper.addEventListener('click', function(event) {
                event.preventDefault();    
                event.stopPropagation(); 
                
                // ⭐ FIX: We search for the closest parent with the bundle key
                const productDetail = wrapper.closest('[data-bundle-key]'); 
                if (!productDetail) {
                    console.error("Missing data-bundle-key attribute on the product parent.");
                    return;
                }
                
                const imageUrl = productDetail.dataset.productImage;
                const bundleLink = productDetail.dataset.bundleKey; // e.g., /apps/gbb/easybundle/6
                
                // 1. LOOKUP DATA FROM THE GLOBAL MAP (bundleConfig)
                let matchingData = [];
                
                // Iterate over bundleConfig keys to find the matching part
                for (const key in bundleConfig) {
                    if (bundleLink.includes(key)) {
                        matchingData = bundleConfig[key];
                        break;
                    }
                }
                
                if (popupImage) {
                    popupImage.src = imageUrl;
                }
                
                // 2. GENERATE LIST HTML
                let listHtml = '<li>Bundle details not found in configuration map.</li>';
                if (matchingData.length > 0) {
                    listHtml = matchingData.map(item => `<li>${item}</li>`).join('');
                }
                
                popupList.innerHTML = listHtml;
                
                // 3. Display the pop-up
                popupWrapper.style.display = 'flex';
                document.body.style.overflow = 'hidden';
            });
            wrapper.setAttribute('data-listeners-attached', 'true'); 
        });

        // --- Attach Close Handlers (once) ---
        if (closeButton && !closeButton.hasAttribute('data-listeners-attached')) {
            function closePopup() {
                popupWrapper.style.display = 'none';
                document.body.style.overflow = '';
            }

            closeButton.addEventListener('click', closePopup);
            popupWrapper.addEventListener('click', function(event) {
                if (event.target === popupWrapper) {
                    closePopup();
                }
            });
            closeButton.setAttribute('data-listeners-attached', 'true');
        }
    }


    // --- MutationObserver Setup ---
    const observer = new MutationObserver(function(mutations, obs) {
        const grid = document.querySelector('.custom-collection-grid');
        if (grid && grid.querySelector('.product-image-wrapper')) {
            attachClickHandlers();
            obs.disconnect(); 
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
}


// =========================================================
// 3. EXECUTION
// =========================================================

// Execute the footer modification repeatedly
setInterval(collectionBundle, 1000); 

// Run the interaction setup to begin observation
document.addEventListener('DOMContentLoaded', setupProductInteractions);